import { Component, inject, input } from '@angular/core';
import { AbstractControl, FormGroup, FormsModule, NonNullableFormBuilder, ReactiveFormsModule, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { UrlService } from '../../services/url.service';
import { finalize } from 'rxjs';
import { ToastService } from '../../../shared/services/toast.service';
import { LoadingButtonComponent } from "../../../shared/components/loading-button/loading-button.component";

@Component({
    selector: 'app-url-pattern-edit-modal',
    imports: [FormsModule, ReactiveFormsModule, LoadingButtonComponent],
    templateUrl: './url-pattern-edit-modal.component.html',
    styleUrl: './url-pattern-edit-modal.component.scss'
})
export class UrlPatternEditModalComponent {
	private readonly fb = inject(NonNullableFormBuilder);
	private readonly urlSrv = inject(UrlService);
	private readonly toastSrv = inject(ToastService);
	activeModal = inject(NgbActiveModal);

	readonly urlList = input<string[]>();
	readonly contextId = input.required<string>();

	showConfirmMessage: boolean = false;
	loading: boolean = false;

	urlPatternForm: FormGroup = this.fb.group(
		{
			includedUrls: [undefined, [Validators.minLength(4)]],
			excludedUrls: [undefined, [Validators.minLength(4)]]
		},
		{ validators: this.atLeastOneRequired }
	);

	// Custom validator to ensure at least one field is filled
	private atLeastOneRequired(control: AbstractControl): { [key: string]: boolean } | null {
		const includedUrls = control.get('includedUrls')?.value?.trim();
		const excludedUrls = control.get('excludedUrls')?.value?.trim();

		if (!includedUrls && !excludedUrls) {
			return { atLeastOneRequired: true };
		}
		return null;
	}

	onSubmit(): void {
		const includedUrls: string[] = this.urlPatternForm.controls['includedUrls'].getRawValue()?.split('\n');
		const excludedUrls: string[] = this.urlPatternForm.controls['excludedUrls'].getRawValue()?.split('\n');

		const includedUrlsMapped: { pattern: string, patternType: 'INCLUDE' | 'EXCLUDE' }[] = includedUrls?.map(e => { return { pattern: e, patternType: 'INCLUDE' } }) || [];
		const excludedUrlsMapped: { pattern: string, patternType: 'INCLUDE' | 'EXCLUDE' }[] = excludedUrls?.map(e => { return { pattern: e, patternType: 'EXCLUDE' } }) || [];

		this.apiSaveUrls([...includedUrlsMapped, ...excludedUrlsMapped]);
	}


	private apiSaveUrls(patterns: { pattern: string; patternType: 'INCLUDE' | 'EXCLUDE' }[]) {
		this.loading = true;
		this.urlSrv.startUrls(this.contextId(), patterns)
			.pipe(finalize(() => this.loading = false))
			.subscribe({
				next: () => {
					this.toastSrv.show({ type: 'success', message: $localize`Pattern Url aggiunte con successo` });
					this.activeModal.close();
				}
			});
	}
}
